/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Scope_Output5Inputs */

const en_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation map`)
};

const ar_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة المحادثة`)
};

const bn_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কথোপকথন মানচিত্র`)
};

const de_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächslandkarte`)
};

const es_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de conversación`)
};

const fr_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte de conversation`)
};

const pt_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de conversa`)
};

const zh_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话地图`)
};

const tr_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sohbet haritası`)
};

const ru_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта диалогов`)
};

const pl_svc_messaging_bots_scope_output5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa rozmowy`)
};

/**
* | output |
* | --- |
* | "Conversation map" |
*
* @param {Svc_Messaging_Bots_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_scope_output5 = /** @type {((inputs?: Svc_Messaging_Bots_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_scope_output5(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_scope_output5(inputs)
	if (locale === "de") return de_svc_messaging_bots_scope_output5(inputs)
	if (locale === "es") return es_svc_messaging_bots_scope_output5(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_scope_output5(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_scope_output5(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_scope_output5(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_scope_output5(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_scope_output5(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_scope_output5(inputs)
	return en_svc_messaging_bots_scope_output5(inputs)
});
export { svc_messaging_bots_scope_output5 as "svc_messaging-bots_SCOPE_output" }